export const parsePreviewUrl = (url: string) =>
  url.replace(
    /^https:\/\/(www\.)?storydoc\.com/,
    "https://stories.storydoc.com",
  );
